<template>
  <div class="custom-card page-wrapper">
    <!-- Header Section with sleek gradient and icon -->
    <!--<div class="header-container mb-5 py-4 px-6 rounded-lg d-flex align-center justify-space-between flex-wrap gap-3">
      <div class="d-flex align-center">
        <div class="header-icon-container mr-4">
          <v-icon color="primary" size="32">mdi-account-cash</v-icon>
        </div>
        <div>
          <h1 class="header-title text-h6 font-weight-bold">
            Docentes: Seguimiento
            <span class="header-divider px-1 text-subtitle-1 grey--text text--lighten-1">|</span>
            <span class="header-highlight primary--text">Control Detallado por Sede</span>
          </h1>
          <p class="header-subtitle mb-0 text-caption text-sm-body-2">
            Filtra por sede y rango de años
          </p>
        </div>
      </div>
    </div>-->

    <ControlDetalladoPagoDocentePorSedeTab />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ControlDetalladoPagoDocentePorSedeTab from '../components/ControlDetalladoPagoDocentePorSedeTab.vue';

export default {
  name: 'ControlDetalladoPagoDocentePorSedePage',
  components: {
    ControlDetalladoPagoDocentePorSedeTab,
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 16px;
  margin: 0px 8px 0px 8px;
}

.page-wrapper {
  background-color: #fafbfc;
  border-radius: 12px;
}

.header-container {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  position: relative;
  overflow: hidden;
}

.header-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #1565c0 0%, #1e40af 100%);
}

.header-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(21, 101, 192, 0.08);
}

.header-title {
  color: #1e293b;
  margin: 0;
  line-height: 1.2;
}

.header-highlight {
  font-weight: 600;
}

.header-subtitle {
  color: #64748b;
  margin-top: 4px;
  font-weight: 500;
}

.gap-3 {
  gap: 12px;
}
</style>

